<template>
  <div>
    <div v-wechat-title="'最强蜗牛丨吃！吃的就是年夜饭！'"></div>
    <div class="pc-page" v-show="pcShow">
      <div class="logo"></div>
      <div class="code"></div>
    </div>
  </div>

</template>
<script>
import { getTimeStamp , buriedLogger } from '@/utils/utils';
import { mapActions } from 'vuex';
export default {
  components: {},
  data () {
    return {
      enterLink: '',
      pcShow: false
    };
  },
  created () {
    const bl = buriedLogger('snail', '蜗牛_年夜饭h5_PC端');  // 埋点
    this.logger = bl;
  },
  mounted () {
    this.$nextTick(() => {
      // 分享
      const { protocol, host } = window.location;
      this.enterLink = `${protocol}//${host}/snail/nyf/enter${getTimeStamp()}`;
      this.monitoringEquipment();
      this.isSetShare(this.enterLink);
    });
  },
  computed: {},
  methods: {
    monitoringEquipment() {
      if (navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) {
        location.href = this.enterLink;
      } else {
        this.pcShow = true;
      }
    },
    // 微信分享
    isSetShare(linkUrl) {
      this.setShare({
        link: linkUrl + `${getTimeStamp()}`,
        title: '最强蜗牛丨吃！吃的就是年夜饭！',
        imgUrl: 'https://download4.qcplay.com/qcgame-api/7FDNuo4e1g2R1xzvYW2rNhm4BN89Q8sY2bUyDhqa.jpeg',
        desc: '嘎嘣脆的龙珠，爆汁的源兽蛋！给蜗爷溜着边儿吃！',
      })
    },
    ...mapActions(["setShare"])
  }
};
</script>

<style lang="less">
  @import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/snail/nyf/pc/index.vue